import React from "react"
import { Flex } from "@capioweb/ui-components/src"
import {
	ContentAreaProperty,
	QBankImage,
	XhtmlString,
} from "../../@types/CapioWeb/core"
import {
	LinkProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { PageBaseProps } from "../../components/Core/pageBase"
import { BlockResolver, CommonHeroBlock } from "../../components"
import { EpiContext } from "../../context"
import { shouldRender } from "../../utils"
import { useLocation } from "react-router-dom"
import { scrollToAnchor } from "../../utils/scrollToAnchor"

interface CapioNexusUnitListingPageProps extends PageBaseProps {
	mainContent: ContentAreaProperty
	regionCooperationText: StringProperty
	regionCooperationImageBlock: QBankImage
	header: StringProperty
	preamble: XhtmlString
	cta: LinkProperty
}

const CapioNexusUnitListingPage: React.FC<CapioNexusUnitListingPageProps> = (
	props
) => {
	const { editMode } = React.useContext(EpiContext)

	const { hash } = useLocation()

	const id = decodeURI(hash.substring(1))

	const el = document?.getElementById(id)

	React.useEffect(() => {
		if (el) {
			//Scroll to anchorID position if it exists
			scrollToAnchor(el)
		}
	}, [el]) //UseEffect will run again when 'el' is ready

	return (
		<Flex display="block" w={1}>
			<CommonHeroBlock
				heading={props.header}
				preamble={props.preamble}
				heroWhite={props.heroWhite}
				Cta={props.cta}
			/>
			{shouldRender(editMode.inEditMode, props.mainContent?.value) && (
				<div data-epi-edit="mainContentArea">
					<BlockResolver blocks={props.mainContent?.value} />
				</div>
			)}
		</Flex>
	)
}

export { CapioNexusUnitListingPage }
